import { motion } from 'framer-motion';

const WhyChoose = () => {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Flexible Scheduling',
      description: 'Evening and weekend appointments available to fit your busy schedule',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Mobile Convenience',
      description: 'We travel to your preferred location—no need to find parking or take time off work',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Fully Credentialed',
      description: 'Illinois commissioned, bonded, insured, and background-screened for your peace of mind',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Professional & Respectful',
      description: 'Calm, patient approach especially helpful for elderly, hospitalized, or first-time signers',
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Detail-Oriented',
      description: 'Every document is handled with precision to ensure proper execution and compliance',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Clear Communication',
      description: 'Prompt responses and transparent pricing—no surprises or hidden fees',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-navy mb-4">
            Why Choose JSJ Burton Enterprises, LLC
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto font-body">
            Experience the difference of working with a dedicated mobile notary who puts your needs first
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="flex gap-4"
            >
              <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center flex-shrink-0">
                <i className={`${benefit.icon} text-teal text-xl`}></i>
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-navy mb-2">
                  {benefit.title}
                </h3>
                <p className="text-base text-gray-600 font-body leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-16 bg-navy/5 rounded-lg p-8 border border-navy/10"
        >
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl font-heading font-bold text-navy mb-4 text-center">
              Service Area Coverage
            </h3>
            <p className="text-base text-gray-700 font-body text-center mb-6">
              Mobile notary services available throughout the following Illinois counties:
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              {['Will', 'DuPage', 'Cook', 'Kane', 'Kendall', 'DeKalb'].map((county, idx) => (
                <span 
                  key={idx}
                  className="px-6 py-2 bg-white border border-navy/20 rounded-full text-navy font-semibold text-base"
                >
                  {county}
                </span>
              ))}
            </div>
            <p className="text-sm text-gray-600 font-body text-center mt-6">
              Need service near a county border or have a special request? Contact us—many accommodations can be made based on schedule and distance.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChoose;
